import React from "react";
import { omit } from "lodash";

const styles = {
  label: {
    display: "inline-block",
    padding: 4,
    paddingLeft: 0,
    marginRight: 20,
    cursor: "pointer",
    fontSize: 14,
  },
  radio: {
    margin: "0 0 0 2px",
    width: "initial",
    height: "initial",
    marginRight: 8,
    fontSize: 16,
  },
};

/**
 * Deprecated, use material for new code
 * */
export const RadioBasic: React.FC<{
  name: string;
  label?: string;
  value?: any;
  onChangeAction?: any;
  style?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  formData?: any;
  defaultChecked?: boolean
}> = (props) => {
  const newProps = omit(props, [
    "options",
    "formData",
    "onChangeAction",
    "onBlurAction",
    "persistTableName",
    "labelStyle",
  ]);
  const { onChangeAction = () => null } = props;
  return (
    <label style={{ ...styles.label, ...props.labelStyle }}>
      <input
        style={{ ...styles.radio, ...props.style }}
        type="radio"
        name={props.name}
        id={`${props.name}-${props.label}`}
        onChange={onChangeAction.bind(null, props)}
        value={props.value}
        {...newProps}
      />
      {props.label}
    </label>
  );
};
